import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María González', 'Juan Pérez', 'Carolina López', 'Martín Rodríguez', 'Luciana Fernández', 'Sofía Martínez', 'Diego Torres', 'Valentina García', 'Julieta Romero', 'Pablo Ruiz'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Loop every 8-12 seconds
    const loopTimer = setInterval(() => {
      showPopup();
    }, Math.random() * 4000 + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(loopTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-210">
      <div className="bg-white border-l-4 border-green-500 shadow-2xl rounded-r-lg p-4 flex items-center gap-4 max-w-xs md:max-w-sm" data-id="element-211">
        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-212">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-213" />
        </div>
        <div data-id="element-214">
          <p className="text-sm font-bold text-gray-900" data-id="element-215">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-216">
            acaba de comprar este programa
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-217">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}